import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  const categoryImages: Record<string, string> = {
    movie: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20clapper%20board%20on%20warm%20wooden%20background%2C%20soft%20dramatic%20lighting%2C%20elegant%20movie%20theme%2C%20classic%20cinema%20aesthetic%2C%20minimalist%20composition%2C%20warm%20golden%20tones&width=600&height=400&seq=cat-movie&orientation=landscape',
    tv: 'https://readdy.ai/api/search-image?query=Modern%20flat%20screen%20television%20in%20cozy%20living%20room%20setting%2C%20warm%20ambient%20lighting%2C%20comfortable%20home%20entertainment%20atmosphere%2C%20minimalist%20interior%20design%2C%20soft%20evening%20mood%2C%20clean%20composition&width=600&height=400&seq=cat-tv&orientation=landscape',
    variety: 'https://readdy.ai/api/search-image?query=Colorful%20stage%20with%20spotlights%20and%20microphone%20stand%2C%20entertainment%20show%20studio%20setting%2C%20vibrant%20concert%20lighting%20effects%2C%20dynamic%20performance%20atmosphere%2C%20bright%20energetic%20colors%2C%20live%20show%20production&width=600&height=400&seq=cat-variety&orientation=landscape',
    anime: 'https://readdy.ai/api/search-image?query=Colorful%20Japanese%20anime%20illustration%20style%20art%20studio%20with%20drawing%20tools%20and%20character%20designs%2C%20vibrant%20manga%20aesthetic%2C%20creative%20workspace%2C%20soft%20natural%20lighting%2C%20whimsical%20atmosphere&width=600&height=400&seq=cat-anime&orientation=landscape',
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            分类浏览
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            精选电影、电视剧、综艺、动漫，总有你想看的
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden aspect-[3/2]"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full mb-3 group-hover:bg-primary-500/80 transition-colors">
                  <i className={`${cat.icon} text-2xl md:text-3xl text-white`}></i>
                </div>
                <span className="text-lg md:text-xl font-semibold text-white">{cat.name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}